import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M12 11v5m9-4a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 7.5,
		r: 1,
		fill: "currentColor"
	})]
});
export default SvgInfo;
